export function formatAgentName(str: string): string {
    if (typeof str === "string" && str) {
        return str.replaceAll(".", " ");
    }
    return str;
}
